// myfrontend/src/components/Form.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../static/form.css';
import '../static/modals.scss';
import '../static/SignaturePad.css';
import PetForm from '../components/PetForm';

import { useLocation } from 'react-router-dom';
import TermsModal from '../components/TermsModal';

const SecondPetForm = () => {
  const location = useLocation();

  // Parse query params
  const queryParams = new URLSearchParams(location.search);
  const phone = queryParams.get('phone') || '';
  const id = queryParams.get('id') || '';



  // Owner Info States
  const [name, setName] = useState('');
  const [phoneMobile, setPhoneMobile] = useState('');
  const [email, setEmail] = useState('');
  const [postcode, setPostcode] = useState('');
  const [address, setAddress] = useState('');
  const [points, setPoints] = useState('');
  const [numberOfVisit, setNumberOfVisit] = useState('');
  const [note, setNote] = useState('');
  const [signature, setSignature] = useState(null);

  // Pet Info States
  const [petName, setPetName] = useState('');
  const [breed, setBreed] = useState('');
  const [catdog, setCatdog] = useState('');
  const [gender, setGender] = useState('');
  const [age, setAge] = useState('');
  const [behaviour, setBehaviour] = useState('');
  const [allergies, setAllergies] = useState('');
  const [vaccinated, setVaccinated] = useState(false);
  const [neutered, setNeutered] = useState(false);
  const [groomingHistory, setGroomingHistory] = useState('');
  const [socialMediaConsent, setSocialMediaConsent] = useState('');
    
    const navigate = useNavigate();
    

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
     
    // Step 2: Create Pet
    const petFormData = new FormData();
    petFormData.append('name', petName || 'Unknown');
    petFormData.append('breed', breed || 'Unknown');
    petFormData.append('catdog', catdog || 'Unknown');
    petFormData.append('phone', phoneMobile || '000-000-0000');
    petFormData.append('gender', gender || 'Unknown');
    petFormData.append('age', age || '0');
    petFormData.append('behaviour', behaviour || 'Not specified');
    petFormData.append('allergies', allergies || '');
    petFormData.append('vaccinated', vaccinated ? 'Yes' : 'No');
    petFormData.append('neutered', neutered ? 'Yes' : 'No');
    petFormData.append('grooming_history', groomingHistory || '');
    petFormData.append('social_media_consent', socialMediaConsent ? 'Yes' : 'No');
    petFormData.append('owner', id); // FK by ID

    

    const petRes = await axios.post('/create-pet/', petFormData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    const petData = petRes.data;

    alert('Owner and Pet created successfully!');
    console.log('Pet created:', petData);

     // ✅ Navigate to PetForm.js and pass owner data
   

  } catch (error) {
    console.error('Submission error:', error.response?.data || error.message);
    alert('Submission failed. Please check the console.');
  }
};

    return (
<section className="contact-wrap" style={{backgroundColor: '#FFFFFF'}}>
 <form onSubmit={handleSubmit} className="contact-form" encType="multipart/form-data">
  {/* Owner Info */}
  
   
   
  {/* Pet Info */}
  <h3>Pet Info</h3>

  <label>Pet Name:</label>
  <div className="input-block">
    <input type="text" value={petName} onChange={(e) => setPetName(e.target.value)} required className="form-control" />
  </div>
<input type="hidden" value={phone} onChange={(e) => setPhoneMobile(e.target.value)} required className="form-control" />
<input type="hidden" value={id} onChange={(e) => setPhoneMobile(e.target.value)} required className="form-control" />
  <label>Breed:</label>
  <div className="input-block">
    <input type="text" value={breed} onChange={(e) => setBreed(e.target.value)} required className="form-control" />
  </div>

  <label>Type (Cat/Dog):</label>
  <div className="input-block">
    <select value={catdog} onChange={(e) => setCatdog(e.target.value)} className="form-control">
      <option value="">Select</option>
      <option value="Cat">Cat</option>
      <option value="Dog">Dog</option>
    </select>
  </div>

  <label>Gender:</label>
  <div className="input-block">
    <select value={gender} onChange={(e) => setGender(e.target.value)} className="form-control">
      <option value="">Select</option>
      <option value="Male">Male</option>
      <option value="Female">Female</option>
    </select>
  </div>

  <label>Age:</label>
  <div className="input-block">
    <input type="number" value={age} onChange={(e) => setAge(e.target.value)} className="form-control" />
  </div>

  <label>Behaviour:</label>
  <div className="input-block">
    <select value={behaviour} onChange={(e) => setBehaviour(e.target.value)} className="form-control">
      <option value="">Select</option>
      <option value="🆕 New">🆕 New</option>
      <option value="😠 Aggressive">😠 Aggressive</option>
      <option value="😊 Gentle">😊 Gentle</option>
      <option value="😳 Shy">😳 Shy</option>
      <option value="🤪 Excited">🤪 Excited</option>
      <option value="😴 Tired">😴 Tired</option>
      <option value="😌 Calm">😌 Calm</option>
      <option value="😨 Fearful">😨 Fearful</option>
      <option value="Naughty behavior">Naughty behavior</option>
    </select>
  </div>

  <label>Allergies:</label>
  <div className="input-block">
    <textarea value={allergies} onChange={(e) => setAllergies(e.target.value)} className="form-control" rows="2" />
  </div>

  <label>Vaccinated:</label>

    <input type="checkbox" checked={vaccinated} onChange={(e) => setVaccinated(e.target.checked)} />

  <label>Neutered:</label>
    <input type="checkbox" checked={neutered} onChange={(e) => setNeutered(e.target.checked)} />

  <label>Grooming History:</label>
 
    <textarea value={groomingHistory} onChange={(e) => setGroomingHistory(e.target.value)} className="form-control" rows="2" />
  

  <label>Social Media Consent:</label>
  <div className="input-block">
     <input type="text" value={socialMediaConsent} onChange={(e) => setSocialMediaConsent(e.target.value)}  className="form-control" />
  </div>



  <label>
    I agree to the vaccination terms
  </label>
  
    <input
      type="checkbox"
      required
      
    />
 

  <div className="">
    <button type="submit" className="square-button">Submit Owner & Pet Info</button>
  </div>
</form>
  <TermsModal />


</section>

    );
};

export default SecondPetForm;
